module.exports = __webpack_public_path__ + "img/Primordial-Process-5.7222b68a.png";